export enum BusinessIdentifiersType {
  chamberCommerceNumber = 'cocNo',
  Abn = 'ABN',
  Ein = 'EIN',
  Kennitala = 'KENNITALA',
  Siret = 'SIRET',
  VhqCustomerId = 'VHQ_CUSTOMER_ID',
  VhqCustomerUniqueId = 'VHQ_CUSTOMER_UNIQUEID',
  VhqRestApiUrl = 'VHQ_REST_API_URL',
  VhqRestApiCustomerId = 'VHQ_REST_API_CUSTOMER_ID',
}
